/**
 * NYC marketplace stats (searchProperties: contractType=coliving, propertyLocation=New York).
 * Update after major US scraper runs — round listings down for stable SEO copy.
 *
 * Last verified: 2026-11-04 — 1,016 active listings (API live count)
 */
module.exports = {
  listingsCount: 1000,
  listingsLabel: '1,000+',
  operatorsCount: null,
  operatorsLabel: null,
};
